export default __webpack_public_path__ + "4c1405f5c19af116e739102611435e1a.svg";